import React from 'react'
import Popup from 'reactjs-popup'
import _ from 'lodash'

const Link = ({ text, href, color }) => (
  <h2 key={text} className={`module-select__title module-select__title--${color}`}>
    <a href={href}>
      Cloud
      <span className="module-select__module-type">
        {text}
      </span>
    </a>
  </h2>
)

const ModuleSelect = ({ links }) => (
  <div className="module-select">
    <Popup
      trigger={popupOpen => (
        <h2 className="module-select__title module-select__title--primary">
          Cloud
          <span className="module-select__module-type">
            Help
          </span>
          <span className={`lnr lnr-chevron-${popupOpen ? 'up' : 'down'}`} />
        </h2>
      )}
      closeOnDocumentClick
      position="bottom center"
      arrow
      offsetY={20}
      contentStyle={{
        padding: null, backgroundColor: null, border: null, boxShadow: null, borderRadius: null
      }}
    >
      <div>
        {_.map(links, link => <Link key={link.text} {...link} />)}
      </div>
    </Popup>
  </div>
)

export default ModuleSelect
